import type { ProductTableFilters } from '@/hooks/useProductTableConfig'
import type { ProductsQuery } from '@/types/products'

/** Maps ProductTableFilters → the ProductsQuery param subset shared by
 *  the list query and the count probe. Single source of truth. */
export function filtersToQueryParams(f: ProductTableFilters): Pick<
  ProductsQuery,
  'is_active' | 'quantity_30d_min' | 'revenue_30d_min' | 'quantity_90d_min' | 'revenue_90d_min' | 'has_image' | 'synced_after'
> {
  return {
    is_active: f.is_active,
    quantity_30d_min: f.quantity_30d_min,
    revenue_30d_min: f.revenue_30d_min,
    quantity_90d_min: f.quantity_90d_min,
    revenue_90d_min: f.revenue_90d_min,
    has_image: f.has_image,
    synced_after: f.synced_after,
  }
}
